import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAfterTideAuth } from '../../context/AfterTideAuthContext';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
const AgeGate = () => {
  const {
    verify
  } = useAfterTideAuth();
  const navigate = useNavigate();
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const location = useLocation();
  // Return readers to the AfterTide page they were trying to open
  const from = (location.state as {
    from?: string;
  } | null)?.from;
  const handleConfirm = () => {
    verify();
    navigate(from && from !== '/aftertide/verify' ? from : '/aftertide', {
      replace: true
    });
  };
  const handleReturn = () => {
    navigate('/');
  };
  return <div className={`min-h-screen ${dk.page} flex flex-col items-center justify-center p-4 relative overflow-hidden selection:bg-[#c77dba] selection:text-[#1a1a2e]`} data-id="element-4617" data-mp="1wbe6zwvohw3m">
      <style data-id="element-4618" data-mp="217uv4r2voagp">
        {`
          @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&display=swap');
          .font-playfair { font-family: 'Playfair Display', serif; }
        `}
      </style>

      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#c77dba] opacity-[0.03] blur-[100px] rounded-full pointer-events-none" data-id="element-4619" data-mp="y735h7ns3rgj" />

      <div className={`max-w-md w-full ${dk.surface}/80 backdrop-blur-sm p-10 rounded-2xl border ${dk.borderAccent} shadow-2xl relative z-10 text-center`} data-id="element-4620" data-mp="1789p3plq5ie0">
        <h1 className={`font-playfair text-5xl font-bold ${rt.textPrimary} mb-4 tracking-wide`} data-id="element-4621" data-mp="1gzxc9eb90d9o">
          AfterTide
        </h1>

        <div className="w-12 h-px bg-[#e2b04a]/50 mx-auto mb-6" data-id="element-4622" data-mp="1c2no01zli7nf" />

        <p className={`${dk.textPrimary} text-lg mb-2 font-medium`} data-id="element-4623" data-mp="1q15bbyll9i4t">
          Mature Fiction.
        </p>
        <p className={`${dk.textSecondary} text-sm mb-10 leading-relaxed`} data-id="element-4624" data-mp="1m0bl2ykobr8r">
          Transparent Classification. Reader Control.
        </p>

        <div className="space-y-8" data-id="element-4625" data-mp="1y11jaro6isb6">
          <div data-id="element-4626" data-mp="1y233pmr34r5k">
            <p className={`${dk.textPrimary} text-sm mb-6`} data-id="element-4627" data-mp="1y1jle4xiw0r0">
              This section of the store contains explicit adult content. You
              must be 18 years or older to enter.
            </p>
            <button onClick={handleConfirm} className={`w-full ${rt.primaryButton} font-bold py-3.5 px-6 rounded-lg transition-all duration-200 transform hover:-translate-y-0.5 shadow-[0_0_15px_rgba(226,176,74,0.3)]`} data-id="element-4628" data-mp="27secpnpmlqjb">
              I confirm I am 18 or older
            </button>
          </div>

          <div className={`pt-6 border-t ${dk.border}`} data-id="element-4629" data-mp="2qpp5cpgr5lps">
            <button onClick={handleReturn} className={`${dk.textSecondary} hover:text-[#f5f0e8] text-sm font-medium transition-colors`} data-id="element-4630" data-mp="2qp757hqyyncl">
              Return to LitLaunch
            </button>
          </div>
        </div>
      </div>

      <div className={`absolute bottom-8 text-center px-4 max-w-2xl ${dk.textSecondary}/60 text-xs`} data-id="element-4631" data-mp="39mzh8rxwegu5">
        <p data-id="element-4632" data-mp="34ufub4dbm9co">
          By entering, you agree to our Terms of Service and acknowledge that
          you are legally permitted to view adult content in your jurisdiction.
          AfterTide operates independently from LitLaunch.
        </p>
      </div>
    </div>;
};
export default AgeGate;